// extracted by mini-css-extract-plugin
export default {"title":"RegistrationPage_title__wmlWH","gradient-animation":"RegistrationPage_gradient-animation__KJWcg"};